import script from "./PropertiesWidget.vue?vue&type=script&lang=ts&setup=true"
export * from "./PropertiesWidget.vue?vue&type=script&lang=ts&setup=true"

import "./PropertiesWidget.vue?vue&type=style&index=0&id=1d623e72&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d623e72"]])

export default __exports__